import { render, staticRenderFns } from "./ReturnHome.vue?vue&type=template&id=514eade2&"
import script from "./ReturnHome.vue?vue&type=script&lang=js&"
export * from "./ReturnHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports